export const getTranslations = t => {
  return {
    familyResults: t("kf.viewFamilyResults"),
    viewSterlingResults: t("kf.viewSterlingResults"),
    items: t("kf.plp.items", "Items"),
    bundle: t("kf.plp.bundle", "Bundle"),
    refPrice: t("kf.pdp.label.refPrice", "List"),
    percentOff: t("kf.pdp.label.percentOff", "OFF"),
    inclusiveOfAllTaxes: t(
      "kf.pdp.label.inclusiveOfAllTaxes",
      "Inclusive of all taxes"
    ),
    shopNow: t("kf.plp.label.shopNow", "Shop Now"),
  }
}
